import React from 'react'
import { DragSource } from 'react-dnd'

import CareEnrolmentItem from './view'

const dragSource = {
  beginDrag(props, monitor, component) {
    const { record } = props

    return {
      id: record.id,
      name: [record.first_name, record.last_name].join(' '),

      // callbacks
      mergePending: () => component.mergePending(),
      mergeCompleted: () => component.mergeCompleted(),
      mergeFailed: () => component.mergeFailed()
    }
  }
}

const RenderDragDropComponent = ({ name, data }) => {
  const SetupDrag = DragSource(name, dragSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }))(CareEnrolmentItem)

  return <SetupDrag {...data} />
}

export default props => (
  <RenderDragDropComponent
    name={
      props.record.status === 'only ccs' ? 'ccs_enrolment' : 'ccms_enrolment'
    }
    data={props}
  />
)



// WEBPACK FOOTER //
// ./src/care-enrolments/list-item/index.jsx